import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Button } from 'react-bootstrap';
import { formatDate } from 'utils/functions';
import IconButton from 'components/common/IconButton';
import ExportReportButton from 'components/ExportReportButton';

const ClaimantTableHeader = ({ label = "Claimants", handleBulkActions, searchParams = {}, showClearFilters = false, selectedRowIds, page } = {}) => {
	const formRef = useRef();
	const onClick = async (e) => {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		let bulk_action = e.target?.innerText ? `${e.target.innerText}`.toLowerCase() : '';
		const formData = new FormData(formRef.current);
		let formDataObj = { bulk_action };
		for (let [key, value] of formData) {
			formDataObj[key] = value;
		}
		if (typeof handleBulkActions === 'function' && bulk_action) {
			let selectedRows = Array.isArray(page) ? page.reduce((acc, { isSelected = false, original } = {}) => (
				[...acc, ...(isSelected ? [original] : [])]
			), []) : [];
			let selectedIds = selectedRows.length > 0 ? selectedRows.map(({ id } = {}) => id) : [];
			await handleBulkActions(formDataObj, selectedRows, selectedIds);
		}
	};

	const onSubmit = async (e) => {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		const formData = new FormData(formRef.current);
		let formDataObj = {};
		for (let [key, value] of formData) {
			formDataObj[key] = value;
		}
		if (typeof handleBulkActions === 'function' && formDataObj.bulk_action) {
			let selectedRows = Array.isArray(page) ? page.reduce((acc, { isSelected = false, original } = {}) => (
				[...acc, ...(isSelected ? [original] : [])]
			), []) : [];
			let selectedIds = selectedRows.length > 0 ? selectedRows.map(({ id } = {}) => id) : [];
			await handleBulkActions(formDataObj, selectedRows, selectedIds);
		}
	};

	return (
		<Form noValidate ref={formRef} onSubmit={onSubmit} className="row flex-between-center">
			<Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
				<h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">{label}</h5>
			</Col>
			<Col xs={8} sm="auto" className="ms-auto text-end ps-0">
				{Object.keys(selectedRowIds).length > 0 ? (
					<div className="d-flex">
						{/* <Form.Select size="sm" aria-label="Bulk actions" name="bulk_action" className="flex-grow-1 w-auto">
							<option value="send-notification">Send Notification</option>
							<option value="disable">Disable</option>
						</Form.Select> */}
						<Button type="submit" variant="falcon-default" size="sm" className="ms-2" >Apply</Button>
						<ExportReportButton
							controllerName="Claimant"
							fnName="searchAllClaimantFn"
							saveAs={`${label.trim()}_${formatDate(new Date(), "YYYY-MM-DD")}.xlsx`}
							params={{
								...searchParams,
								offset: 0,
								limit: null,
								selectedRowIds: Array.isArray(page)
									? (page.reduce((acc, { isSelected = false, original } = {}) => (
										[...acc, ...(isSelected ? [original] : [])]
									), [])).map(({ id } = {}) => id)
									: []
							}}
						/>
					</div>
				) : (
					<div id="orders-actions">
						{/* {showClearFilters && <IconButton
							size="sm"
							variant="outline-danger"
							className="me-2"
							icon="clear"
							type="button"
							onClick={onClick}
						>Clear Filters</IconButton>} */}
						{/* <IconButton
							variant="falcon-default"
							size="sm"
							icon="filter"
							transform="shrink-3"
							className="mx-2"
							type="button"
							onClick={onClick}
						>
							<span className="d-none d-sm-inline-block ms-1">Find-A-Claimant</span>
						</IconButton> */}
						{/* <IconButton
							variant="falcon-default"
							size="sm"
							icon="plus"
							transform="shrink-3"
							type="button"
							onClick={onClick}
						>
							<span className="d-none d-sm-inline-block ms-1">New Claimant</span>
						</IconButton> */}
						<ExportReportButton
							controllerName="Claimant"
							fnName="searchAllClaimantFn"
							saveAs={`${label.trim()}_${formatDate(new Date(), "YYYY-MM-DD")}.xlsx`}
							params={{
								...searchParams,
								offset: 0,
								limit: null,
								selectedRowIds: Array.isArray(page)
									? (page.reduce((acc, { isSelected = false, original } = {}) => (
										[...acc, ...(isSelected ? [original] : [])]
									), [])).map(({ id } = {}) => id)
									: []
							}}
						/>
					</div>
				)}
			</Col>
		</Form>
	);
};

ClaimantTableHeader.propTypes = {
	label: PropTypes.string,
	handleBulkActions: PropTypes.func,
	searchParams: PropTypes.object,
	showClearFilters: PropTypes.bool,
	selectedRowIds: PropTypes.object,
	page: PropTypes.array,
};

export default ClaimantTableHeader;